import { render } from "./RewardRedeem.vue?vue&type=template&id=483ed53c&scoped=true"
import script from "./RewardRedeem.vue?vue&type=script&lang=js"
export * from "./RewardRedeem.vue?vue&type=script&lang=js"

import "./RewardRedeem.vue?vue&type=style&index=0&id=483ed53c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483ed53c"]])

export default __exports__